import { useState } from "react";
import { Box, IconButton, Stack, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RefreshIcon from "@mui/icons-material/Refresh";

const clamp = (v) => Math.min(Math.max(v, 1), 5);

const ZoomableImage = ({ src }) => {
  const [scale, setScale] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [drag, setDrag] = useState(null);

  const reset = () => {
    setScale(1);
    setPos({ x: 0, y: 0 });
  };

  return (
    <Paper
      variant="outlined"
      sx={{ height: "100%", overflow: "hidden", position: "relative" }}
      onWheel={(e) => setScale((s) => clamp(s + (e.deltaY < 0 ? 0.15 : -0.15)))}
      onMouseMove={(e) =>
        drag &&
        setPos({
          x: e.clientX - drag.x,
          y: e.clientY - drag.y,
        })
      }
      onMouseUp={() => setDrag(null)}
      onMouseLeave={() => setDrag(null)}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{ position: "absolute", top: 8, right: 8, zIndex: 2, backgroundColor: "white" }}
      >
        <IconButton size="small" onClick={() => setScale((s) => clamp(s - 0.25))}>
          <RemoveIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => setScale((s) => clamp(s + 0.25))}>
          <AddIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={reset}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>

      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: scale > 1 ? "grab" : "default",
        }}
        onMouseDown={(e) => scale > 1 && setDrag({ x: e.clientX - pos.x, y: e.clientY - pos.y })}
      >
        <Box
          component="img"
          src={src}
          draggable={false}
          sx={{
            maxWidth: "100%",
            maxHeight: "100%",
            transform: `translate(${pos.x}px, ${pos.y}px) scale(${scale})`,
            transition: drag ? "none" : "transform 0.15s ease-out",
            userSelect: "none",
            pointerEvents: "none",
          }}
        />
      </Box>
    </Paper>
  );
};

export default ZoomableImage;
